const REASON_LABELS = { Resign: "Resigned", Terminate: "Terminated", Contract: "Contract ended", Absconding: "Absconded" };

/** The original head-count endpoint's rows, in the shape the month charts
 *  take: same numbers as the old New Employees / Resigned / Head Count cards. */
export const fromHeadcountRows = (rows) =>
  (rows || []).map((r) => ({
    month: String(r.month).slice(0, 7),
    headcount: r.current_employees,
    hires: r.new_employees,
    leavers: r.terminations,
    leavers_by_reason: Object.fromEntries(
      Object.entries(r.termination_reasons || {}).map(([key, value]) => [REASON_LABELS[key] || key, value])
    ),
  }));
